import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueLazyload from 'vue-lazyload'

const placeholder = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: placeholder,
  loading: placeholder,
  attempt: 1,
  lazyComponent: true,
})

Vue.config.productionTip = false

import Teleport from 'vue2-teleport'
Vue.component('Teleport', Teleport)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')